/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportIlsDto } from '../../models/import-ils-dto';

export interface IlsControllerImportIls$Params {
  folderId: string;
      body: ImportIlsDto
}

export function ilsControllerImportIls(http: HttpClient, rootUrl: string, params: IlsControllerImportIls$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerImportIls.PATH, 'post');
  if (params) {
    rb.path('folderId', params.folderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

ilsControllerImportIls.PATH = '/ils/{folderId}/import';
